"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var LockIcon = function LockIcon(props) {
  return _react["default"].createElement("svg", {
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 100",
    width: props.width || "56px",
    height: props.height || "70px"
  }, _react["default"].createElement("g", null, _react["default"].createElement("g", {
    transform: "translate(-110.000000, -100.000000)",
    fill: props.fill || "#71c4ff"
  }, _react["default"].createElement("g", {
    transform: "translate(110.000000, 100.000000)"
  }, _react["default"].createElement("path", {
    d: "M18,26 C18,13.869 27.869,4 40,4 C52.131,4 62,13.869 62,26 L62,40 L18,40 L18,26 Z M78,40 L66,40 L66,26 C66,11.663 54.337,0 40,0 C25.664,0 14,11.663 14,26 L14,40 L2,40 C0.896,40 0,40.896 0,42 L0,93.826 C0,97.23 2.792,100 6.223,100 L32.117,100 C33.222,100 34.117,99.105 34.117,98 C34.117,96.896 33.222,96 32.117,96 L6.223,96 C4.997,96 4,95.024 4,93.826 L4,44 L76,44 L76,93.826 C76,95.024 75.003,96 73.778,96 L43.998,96 C42.896,96 42,95.105 42,94.003 L42,78 C42,76.896 41.105,76 40,76 C38.896,76 38,76.896 38,78 L38,94.003 C38,97.31 40.69,100 43.998,100 L73.778,100 C77.209,100 80,97.23 80,93.826 L80,42 C80,40.896 79.105,40 78,40 Z"
  }), _react["default"].createElement("path", {
    d: "M40,71.2503 C41.381,71.2503 42.5,70.1313 42.5,68.7503 C42.5,67.3693 41.381,66.2503 40,66.2503 C38.619,66.2503 37.5,67.3693 37.5,68.7503 C37.5,70.1313 38.619,71.2503 40,71.2503"
  })))));
};

var _default = LockIcon;
exports["default"] = _default;